class PasswordModal extends DetailsModal {
  constructor() {
    super();
    // Entferne die Logik für das Öffnen/Schließen
  }
}

customElements.define('password-modal', PasswordModal);




